import React from 'react';
import { Lock, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

const LockedInsightCard = ({ 
  icon: Icon, 
  title, 
  teaser, 
  onClick,
  className = "" 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      className={`relative overflow-hidden rounded-2xl border border-white/10 bg-[#0F131F] ${className}`}
    >
      {/* Glassmorphism Overlay */}
      <div className="absolute inset-0 backdrop-blur-xl bg-slate-900/60"></div>
      
      {/* Locked Badge */}
      <div className="absolute top-4 right-4 z-20">
        <div className="flex items-center space-x-1 bg-yellow-500/20 border border-yellow-500/50 rounded-full px-3 py-1">
          <Lock className="w-3 h-3 text-yellow-400" />
          <span className="text-xs font-bold text-yellow-400 font-mono uppercase">Premium</span>
        </div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 p-6">
        <div className="flex items-start space-x-4 mb-4">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-teal-500/20 flex items-center justify-center border border-emerald-500/30">
            <Icon className="w-6 h-6 text-emerald-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-white mb-2 font-mono">{title}</h3>
            <p className="text-sm text-slate-400 font-mono">{teaser}</p>
          </div>
        </div>
        
        {/* CTA Button */}
        <button
          onClick={onClick}
          className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white py-3 px-4 rounded-xl font-semibold hover:scale-105 transition-all flex items-center justify-center space-x-2 font-mono"
        >
          <Sparkles className="w-4 h-4" />
          <span>UNLOCK WITH PREMIUM</span>
        </button>
      </div>
      
      {/* Corner Brackets */}
      <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-emerald-500/30 z-10" />
      <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-emerald-500/30 z-10" />
      <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-emerald-500/30 z-10" />
      <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-emerald-500/30 z-10" />
    </motion.div>
  );
};

export default LockedInsightCard;

